import React, { useEffect, useState } from "react";
import { StreamChat } from "stream-chat";
import {
  Chat,
  Channel,
  ChannelHeader,
  ChannelList,
  LoadingIndicator,
  MessageInput,
  MessageList,
  Thread,
  Window,
} from "stream-chat-react";
import { getChatToken } from "../../service/api";

import TopBar from "./TopBar";

function UserChats() {
  const [chatClient, setChatClient] = useState(null);

  const user_data = JSON.parse(sessionStorage.getItem("userdata"));

  let user_email = user_data.email.replaceAll(".", "_");
  user_email = user_email.replaceAll("@", "_");
  user_email = user_email.toLowerCase();

  const filters = { type: "messaging", members: { $in: [user_email] } };
  const sort = { last_message_at: -1 };

  useEffect(() => {
    const initChat = async () => {
      const client = StreamChat.getInstance("hr5n668dxhz3");
      const userToken = await getChatToken(user_email);

      await client.connectUser(
        {
          id: user_email,
          name: user_data.name,
        },
        userToken.token
      );

      setChatClient(client);
    };

    initChat();
  }, []);

  if (!chatClient) {
    return <LoadingIndicator />;
  }

  return (
    <div className="bg h-full min-h-screen">
      <TopBar />
      <Chat client={chatClient} theme="messaging light">
        <ChannelList filters={filters} sort={sort} />
        <Channel>
          <Window>
            <ChannelHeader />
            <MessageList />
            <MessageInput />
          </Window>
          <Thread />
        </Channel>
      </Chat>
    </div>
  );
}

export default UserChats;
